import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import {
  ChatBubbleLeftRightIcon,
  SunIcon,
  FlagIcon,
  Squares2X2Icon,
  MagnifyingGlassIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/outline";
import TimelyzerLogo from "../brand/TimelyzerLogo";
import { workspaceService } from "../../services/api";
import { workspaces } from "../workspace/workspaces";
export const utilityTabs = workspaces;
const tabs = [
  { to: "/ai", label: "Assistant", icon: ChatBubbleLeftRightIcon },
  { to: "/today", label: "Today", icon: SunIcon },
  { to: "/goals", label: "Goals", icon: FlagIcon },
  { to: "/library", label: "Library", icon: Squares2X2Icon },
];
export default function BottomTabNav() {
  const location = useLocation();
  const { data } = useQuery({
    queryKey: ["workspace-preferences"],
    queryFn: workspaceService.preferences,
    staleTime: 60000,
  });
  const pins = data?.pins || ["notes", "calendar", "challenges"];
  const item = (tab, mobile = false) => {
    const Icon = tab.icon;
    return (
      <NavLink
        key={tab.to}
        to={tab.to}
        className={`unified-nav-item ${mobile ? "mobile" : ""} ${location.pathname === tab.to ? "selected" : ""}`}
      >
        <Icon aria-hidden="true" />
        <span>{tab.label}</span>
      </NavLink>
    );
  };
  return (
    <>
      <aside className="unified-sidebar">
        <NavLink to="/ai" aria-label="Timelyzer home">
          <TimelyzerLogo descriptor="Your personal assistant" />
        </NavLink>
        <button
          className="workspace-search-trigger"
          onClick={() => window.dispatchEvent(new Event("timelyzer:search"))}
        >
          <MagnifyingGlassIcon aria-hidden="true" />
          Search everything<kbd>⌘ K</kbd>
        </button>
        <nav aria-label="Primary navigation">
          {tabs.map((tab) => item(tab))}
        </nav>
        <div className="unified-pins">
          <p className="workspace-eyebrow">Pinned workspaces</p>
          <nav aria-label="Pinned workspaces">
            {pins
              .map((key) => workspaces.find((w) => w.id === key))
              .filter(Boolean)
              .map((tab) => item(tab))}
          </nav>
          <NavLink className="workspace-text-link" to="/library">
            Browse your library
          </NavLink>
        </div>
        <div className="unified-sidebar-footer">
          <p>
            One assistant.
            <br />
            Your whole life.
          </p>
          <NavLink className="unified-nav-item" to="/preferences">
            <Cog6ToothIcon aria-hidden="true" />
            Settings & memory
          </NavLink>
        </div>
      </aside>
      <nav
        aria-label="Mobile navigation"
        className="unified-mobile-nav bottom-nav-safe"
      >
        {tabs.map((tab) => item(tab, true))}
      </nav>
    </>
  );
}
